export const initialCategories = [
  { id: 1, name: "إلكترونيات", description: "أجهزة إلكترونية ذكية وحديثة" },
  { id: 2, name: "ملابس", description: "أزياء حديثة ومريحة" },
  { id: 3, name: "أحذية", description: "أحذية رياضية وكلاسيكية" },
];

export const initialProducts = [
  // إلكترونيات
  {
    id: 1,
    name: "Apple iPhone 14 Pro",
    description: "هاتف ذكي بأحدث المواصفات والكاميرات الاحترافية",
    price: 1200,
    stockQuantity: 10,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/iphone-14-pro.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 2,
    name: "MacBook Pro 16",
    description: "لابتوب فائق الأداء للأعمال والتصميم، معالج M2 وشاشة ريتنا.",
    price: 2500,
    stockQuantity: 5,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/macbook-pro-16.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 3,
    name: "Apple Watch Series 8",
    description: "ساعة رياضية لمتابعة الصحة ونبضات القلب والنشاط اليومي.",
    price: 399,
    stockQuantity: 15,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/apple-watch-series-8.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 4,
    name: "Sony WH-1000XM5",
    description: "سماعات عازلة للضوضاء ذات جودة صوت استثنائية.",
    price: 350,
    stockQuantity: 12,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/sony-wh-1000xm5.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 5,
    name: "iPad Air",
    description: "جهاز لوحي خفيف وقوي للعمل والترفيه.",
    price: 600,
    stockQuantity: 8,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/ipad-air.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 6,
    name: "Canon EOS R5",
    description: "كاميرا احترافية بدون مرآة لعشاق التصوير.",
    price: 3800,
    stockQuantity: 3,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/canon-eos-r5.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 7,
    name: "Samsung Galaxy S23",
    description: "هاتف أندرويد قوي مع شاشة مذهلة وكاميرا فائقة.",
    price: 850,
    stockQuantity: 20,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/samsung-galaxy-s23.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 8,
    name: "Nintendo Switch OLED",
    description: "جهاز ألعاب محمول بشاشة OLED مذهلة.",
    price: 350,
    stockQuantity: 25,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/nintendo-switch-oled.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 9,
    name: "DJI Mavic 3",
    description: "طائرة درون احترافية لتصوير سينمائي من الجو.",
    price: 2200,
    stockQuantity: 4,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/dji-mavic-3.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 10,
    name: "Keychron K2 Keyboard",
    description: "لوحة مفاتيح ميكانيكية لاسلكية بتصميم كلاسيكي.",
    price: 100,
    stockQuantity: 30,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/keychron-k2.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 11,
    name: "Logitech MX Master 3S",
    description: "أفضل فأرة إنتاجية للمصممين والمبرمجين.",
    price: 99,
    stockQuantity: 40,
    categoryId: 1,
    categoryName: "إلكترونيات",
    image: require("../assets/ProductsImage/logitech-mx-master-3s.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },

  // ملابس
  {
    id: 12,
    name: "جاكيت شتوي أنيق",
    description: "جاكيت ثقيل ومريح للأجواء الباردة.",
    price: 120,
    stockQuantity: 15,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/jacket-winter.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 13,
    name: "قميص قطني عصري",
    description: "قميص صيفي خفيف وأنيق للمناسبات اليومية.",
    price: 45,
    stockQuantity: 25,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/shirt-cotton.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 14,
    name: "بنطلون جينز كلاسيكي",
    description: "جينز متين وعصري يناسب جميع الإطلالات.",
    price: 75,
    stockQuantity: 30,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/jeans-classic.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 15,
    name: "جاكيت جلدي أسود",
    description: "تصميم جريء ومميز لعشاق الجلود.",
    price: 180,
    stockQuantity: 8,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/jacket-leather-black.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 16,
    name: "هودي رياضي مريح",
    description: "هودي قطني ناعم للتمارين أو الاسترخاء.",
    price: 60,
    stockQuantity: 20,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/hoodie-sporty.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 17,
    name: "وشاح صوفي ناعم",
    description: "إكسسوار مثالي للشتاء لزيادة الدفء والأناقة.",
    price: 30,
    stockQuantity: 50,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/scarf-wool-soft.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 18,
    name: "قبعة صيفية عصرية",
    description: "قبعة خفيفة للحماية من الشمس بلمسة جمالية.",
    price: 25,
    stockQuantity: 60,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/summer-hat.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 19,
    name: "تيشيرت مطبوع مميز",
    description: "تيشيرت قطني برسومات فنية فريدة.",
    price: 35,
    stockQuantity: 40,
    categoryId: 2,
    categoryName: "ملابس",
    image: require("../assets/ProductsImage/t-shirt-printed.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },

  // أحذية
  {
    id: 20,
    name: "حذاء Nike Air Max",
    description: "حذاء رياضي بأعلى مستويات الراحة والأداء.",
    price: 160,
    stockQuantity: 12,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/nike-air-max.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 21,
    name: "حذاء جري Adidas Ultraboost",
    description: "حذاء مثالي للجري لمسافات طويلة بمرونة عالية.",
    price: 180,
    stockQuantity: 10,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/adidas-ultraboost.webp"),
    isFeatured: true,
    averageRating: 5.0,
  },
  {
    id: 22,
    name: "حذاء كلاسيكي جلدي",
    description: "حذاء فاخر للمناسبات الرسمية والعمل بجلد طبيعي.",
    price: 130,
    stockQuantity: 8,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/heels.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 23,
    name: "سنيكرز عصري أبيض",
    description: "حذاء يومي مريح يتناسب مع جميع أنواع الملابس.",
    price: 70,
    stockQuantity: 20,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/sneakers-white.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 24,
    name: "كعب",
    description: "خيار رائع للأيام الحارة وللشاطئ بتصميم خفيف.",
    price: 40,
    stockQuantity: 30,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/heels.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
  {
    id: 25,
    name: "حذاء رياضي Puma",
    description: "حذاء كاجوال بتصميم مميز يجمع بين العصرية والراحة.",
    price: 90,
    stockQuantity: 18,
    categoryId: 3,
    categoryName: "أحذية",
    image: require("../assets/ProductsImage/puma-trainer.webp"),
    isFeatured: false,
    averageRating: 5.0,
  },
];
